export const MAIN_COLOR = 'var(--primary-colour)'
export const RED_COLOR = '#B22222'
export const ACCENT_COLOR = '#ef8f1c'

export const MAX_RIF_AGE = 72

export const MIN_CPP_AGE = 60
export const MAX_CPP_AGE = 70
export const MIN_OAS_AGE = 65
export const MAX_OAS_AGE = 71

export const ACTIVITY_HELPER = 'This section is for entering your recurring transactions. The details button will show you past and future activity for this year so you can accurately enter actual values.'
export const LUMPSUM_HELPER = 'This section is for entering extra activity over and above the recurring payments. The details button will show you past and future activity for this year so you can accurately enter actual values.'
export const ROR_HELPER = 'This is your best guess for the rate at which the value of your investments grow each year (not including new deposits/withdrawals).'

export const DeleteWarning = 'Warning: Deleting this item will remove it from "This Year" and "Future Choices". Are you sure?'

export const passPlaceholder = '1 Upper & Lower case, symbol, number, 8 characters'
export const passSymbols = '! @ # $ % ^ & * ( ) _ + { } : " < > ?'
 
export const globals = {
  currentDate: new Date(),
  currentYear: new Date().getFullYear(),
  nextYear: new Date().getFullYear() + 1,
  defaultInflation: 0.03,
  defaultInterestRate: 0.05, 
}

export function getMonthName(monthNum){
  const month_options = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return month_options[monthNum]
}

export const plansCost = [
  {
    type: 'TRIAL',
    tagline: 'Trial',
    tagcolor: 'blue',
    tagwidth: '65px',
    label: 'FREE',    
    desc: '7 Day Trial',
    billed: '',
    hdrcolor: 'blue',
    btncolor: 'blue',
    cost: 0
  },{
    type: '1MONTH',
    tagline: 'Base',
    tagcolor: 'grey',
    tagwidth: '65px',
    label: '$40.00',
    desc: 'One Month',
    billed: 'every month',
    hdrcolor: 'nometa',
    btncolor: 'orange',
    cost: 40.00
  },{
    type: '12MONTH',
    tagline: 'Most Popular',
    tagcolor: 'red',
    tagwidth: '110px',
    label: '$20.00',
    desc: '12 Months',
    billed: 'annually',
    hdrcolor: 'green',
    btncolor: 'green',
    cost: 240.00
  },{
    type: '6MONTH',
    tagline: 'A 17.5% Discount',
    tagcolor: 'green',
    tagwidth: '135px',
    label: '$33.00',    
    desc: '6 Months',
    billed: 'semi-annually',
    hdrcolor: 'nometa',
    btncolor: 'orange',
    cost: 198.00
  }
]

export const PROVINCES = [
  {
    key: 'FED',
    value: 'FED',
    text: 'Federal',
  },
  {
    key: 'AB',
    value: 'AB',
    text: 'Alberta',
  },
  {
    key: 'BC',
    value: 'BC',
    text: 'British Columbia',
  },
  {
    key: 'MB',
    value: 'MB',
    text: 'Manitoba',
  },
  {
    key: 'NB',
    value: 'NB',
    text: 'New Brunswick',
  },
  {
    key: 'NL',
    value: 'NL',
    text: 'Newfoundland & Labrador',
  },
  {
    key: 'NS',
    value: 'NS',
    text: 'Nova Scotia',
  },
  {
    key: 'ON',
    value: 'ON',
    text: 'Ontario',
  },
  {
    key: 'PE',
    value: 'PE',
    text: 'Prince Edward Island',
  },
  {
    key: 'QC',
    value: 'QC',
    text: 'Quebec',
  },
  {
    key: 'SK',
    value: 'SK',
    text: 'Saskatchewan',
  },
  {
    key: 'YT',
    value: 'YT',
    text: 'Yukon',
  },
  {
    key: 'NT',
    value: 'NT',
    text: 'Northwest Territories',
  },
  {
    key: 'NU',
    value: 'NU',
    text: 'Nunavut',
  },
]

export const accountOrderOptions = [
  {value: 1, text: 'Open / TFSA / Registered'}, 
  {value: 2, text: 'Open / Registered / TFSA'}, 
  {value: 3, text: 'TFSA / Open / Registered'}, 
  {value: 4, text: 'TFSA / Registered / Open'}, 
  {value: 5, text: 'Registered / Open / TFSA'}, 
  {value: 6, text: 'Registered / TFSA / Open'}, 
]

export const WAITING = [
  "Please wait while the minions do their work",
  "Grabbing extra minions",
  "Doing the heavy lifting",
  "We're working very Hard .... Really",
  "Waking up the minions",
  "Do you like my loading animation? I made it myself",
  "Don't panic... AHHHHH!",
  "Time waits for no man. Unless that man is Chuck Norris.",
  "Chuck Norris does not sleep. He waits.",
  "Chuck Norris is the reason why Waldo is hiding.",
  "Ensuring Gnomes are still short.",
  "Shovelling coal into the server",
  "What is the airspeed velocity of an unladen swallow?",
  "Computing the secret to life, the universe, and everything.",
  "Unicorns are at the end of this road, I promise.",
]